import { ProtectedRoute } from '@/components/auth/protected-route';
import { RoleGuard } from '@/components/auth/role-guard';
import { AppShell } from '@/components/layout/app-shell';
import { AdminBooksPage } from '@/pages/admin/books';
import { AdminModelsPage } from '@/pages/admin/models';
import { AdminOperatorsPage } from '@/pages/admin/operators';
import { LoginPage } from '@/pages/auth/login';
import { SignupPage } from '@/pages/auth/signup';
import { AlertsHistoryPage } from '@/pages/operator/alerts-history';
import { DashboardPage } from '@/pages/operator/dashboard';
import { ManualPickPage } from '@/pages/operator/manual-pick';
import { MatchCockpitPage } from '@/pages/operator/match-cockpit';
import { PerformancePage } from '@/pages/operator/performance';
import { ReconcilePage } from '@/pages/operator/reconcile';
import { SettingsPage } from '@/pages/operator/settings';
import { SignalsListPage } from '@/pages/operator/signals';
import { Navigate, Route, Routes } from 'react-router-dom';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/matches/:id" element={<MatchCockpitPage />} />
          <Route path="/signals" element={<SignalsListPage />} />
          <Route path="/alerts/history" element={<AlertsHistoryPage />} />
          <Route path="/performance" element={<PerformancePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route element={<RoleGuard requireRole="admin" />}>
            <Route path="/manual-pick" element={<ManualPickPage />} />
            <Route path="/reconcile" element={<ReconcilePage />} />
            <Route path="/admin/operators" element={<AdminOperatorsPage />} />
            <Route path="/admin/books" element={<AdminBooksPage />} />
            <Route path="/admin/models" element={<AdminModelsPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
